module.exports = "https://cdn.hellotech.com/client-assets/home-front-mobile_70c2d88240c95c30304b602b81646aa8.jpg";